const initialState = {
  showEdit: false,
  showAdd: false,
  showDetail: false,
  showApproval: false,
  showMore: false,
  showAdditional: false,
  targetId: null,
  data: null,
  modalName: null,
  approval: null, // employee_id, pin and status_pin
  actionType: "", // action type untuk multiple use approval scenario
  payload: null,
  roleName: "", // for modal input pin ["SUPERVISOR", "ADMIN"]
  //for modal approval
  url: "",
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SHOW_APPROVAL":
      return {
        ...state,
        approval: null,
        roleName: action.payload.roleName ?? "",
        showApproval: action.payload.value,
        payload: action.payload.data ?? null,
        actionType: action.payload.actionType ?? "",
        url: action.payload.url ?? "",
        pin: action.payload.pin ?? "",
        employee_id: action.payload.employee_id ?? "",
      };
    case "SET_APPROVAL_DATA":
      return {
        ...state,
        approval: action.payload ?? null,
      };

    case "SET_DATA":
      return {
        ...state,
        data: action.payload,
      };

    case "SHOW_MORE":
      return {
        ...state,
        data: action.payload.data,
        showMore: action.payload.value,
      };

    case "SHOW_ADD_MODAL":
      return {
        ...state,
        showAdd: action.payload.add,
        showEdit: false,
        showDetail: false,
        targetId: null,
        modalName: action.payload.name ?? null,
      };
    case "SHOW_EDIT_MODAL":
      return {
        ...state,
        showEdit: action.payload.edit,
        showAdd: false,
        showDetail: false,
        targetId: action.payload.id ?? null,
        modalName: action.payload.name ?? null,
      };
    case "SHOW_DETAIL_MODAL":
      return {
        ...state,
        showDetail: action.payload.detail,
        showEdit: false,
        showAdd: false,
        targetId: action.payload.id ?? null,
        data: action.payload.data ?? null,
        modalName: action.payload.name ?? null,
      };
    case "SHOW_ADDITIONAL_MODAL":
      return {
        ...state,
        showAdditional: action.payload.additional,
        showDetail: false,
        showEdit: false,
        showAdd: false,
        data: action.payload.data ?? null,
        targetId: action.payload.id ?? null,
      };
    case "RESET_MODAL":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default modalReducer;
